import { render, staticRenderFns } from "./EditTransportDialog.vue?vue&type=template&id=56d406c6"
import script from "./EditTransportDialog.vue?vue&type=script&lang=ts"
export * from "./EditTransportDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports